import React, { useEffect, useState } from "react";
import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import "./drawdownsummaryofchanges.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { addCommas } from "../../helpers/helpers";
import { Link } from "react-router-dom";
import NotFound from "../../atoms/NotFound";

const DrawSummaryOfChangesModal = (props) => {
  const [showBreakDown, setShowBreakDown] = useState(false);
  const [confirmLocked, setConfirmLocked] = useState(false);

  useEffect(() => {
    if (!props.fundSwitchFetching && !props.flexiAccessFetching) {
      setConfirmLocked(false);
    }
  }, [props.fundSwitchFetching, props.flexiAccessFetching]);

  const handleConfirmClick = () => {
    if (confirmLocked) {
      return;
    }
    setConfirmLocked(true);
    props.handleContinue();
  };

  const toggleInvestments = (e) => {
    e.preventDefault();
    setShowBreakDown(!showBreakDown);
  };

  const forIncomeTooltip = (
    <Popover id="dd-pop-id" className="dd-popover-inner">
      <Popover.Body className="dd-popover-body">
        <div className="pop-text">
          These drawdown options manage your income and investments for you
        </div>
      </Popover.Body>
    </Popover>
  );

  const forGrowthTooltip = (
    <Popover id="dd-pop-id" className="dd-popover-inner">
      <Popover.Body className="dd-popover-body">
        <div className="pop-text">
          These drawdown options aren&apos;t intended for income but you can dip
          in at any time
        </div>
      </Popover.Body>
    </Popover>
  );

  const selfManagedTooltip = (
    <Popover id="dd-pop-id" className="dd-popover-inner">
      <Popover.Body className="dd-popover-body">
        <div className="pop-text">
          This drawdown option enables you to choose your investments and income
        </div>
      </Popover.Body>
    </Popover>
  );

  function formatPercent(val) {
    if (val === null || val === undefined) return "";

    const strVal = String(val).trim();

    if (strVal.endsWith(".00")) {
      return strVal.slice(0, -3);
    }

    return strVal;
  }

  return (
    <div
      className={
        props?.finalDrawdownStrategies !== undefined
          ? "dd-parent-summary-changes"
          : "dd-parent-confirm"
      }
    >
      <Row>
        <Col>
          <div className="dd-summary-small-close">
            <Link to="">
              <Icons
                iconname="close-large"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row
        className={
          props?.finalDrawdownStrategies !== undefined
            ? "dd-summary-title mb-5"
            : "dd-confirm-pop-title mb-2"
        }
      >
        <Col>
          <div>{props.modalTitle}</div>
        </Col>
      </Row>
      {props?.finalDrawdownStrategies !== undefined ? (
        <>
          {props.finalDrawdownStrategies?.every(
            (i) =>
              i?.category !== "For Income" ||
              Number(i?.strategyPercentage2) === 0,
          ) ? (
            ""
          ) : (
            <Row className="dd-summary-of-change mb-5 d-none d-xl-block d-lg-block d-md-block">
              <Col>
                <table>
                  <thead>
                    <tr>
                      <th className="ps-4">
                        Income{" "}
                        <OverlayTrigger
                          placement="right"
                          overlay={forIncomeTooltip}
                          flip={true}
                        >
                          <span className="fa-tooltip">
                            <Icons
                              iconname="tool-tip-white"
                              variant="icon-sixteen-px"
                            />
                          </span>
                        </OverlayTrigger>
                      </th>
                      <th className="dd-col-pad-allocation">Allocation</th>
                      <th className="dd-col-pad-total-value">
                        Estimated value
                      </th>
                      <th className="dd-col-pad-total-value">
                        Your drawdown income
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {props?.finalDrawdownStrategies.map((item, index) => {
                      if (
                        item?.category === "For Income" &&
                        item?.strategyPercentage2 > 0
                      ) {
                        return (
                          <tr className="mt-3" key={index}>
                            <td className="ps-4">
                              <span>{item?.strategyName}</span>
                            </td>
                            <td className="dd-col-pad-allocation">
                              {formatPercent(item?.strategyPercentage1)}%{" "}
                              <Icons
                                iconname="arrow-right-fuchsia"
                                variant="icon-sixteen-px"
                              />{" "}
                              <b>{formatPercent(item?.strategyPercentage2)}%</b>
                            </td>
                            <td className="dd-col-pad-total-value">
                              £{addCommas(Math.trunc(item.currentValue2))}.
                              <span className="dd-eac-pot-value-small-digit">
                                {(item.currentValue2 % 1)
                                  .toFixed(2)
                                  .substring(2)}
                              </span>
                            </td>
                            <td className="dd-col-pad-allocation">
                              £{addCommas(Math.trunc(item.currentIncome1))}.
                              <span className="dd-eac-pot-value-small-digit">
                                {(item.currentIncome1 % 1)
                                  .toFixed(2)
                                  .substring(2)}
                              </span>
                              <Icons
                                iconname="arrow-right-fuchsia"
                                variant="icon-sixteen-px"
                              />{" "}
                              <b>
                                £{addCommas(Math.trunc(item.currentIncome2))}.
                                <span className="dd-eac-pot-value-small-digit">
                                  {(item.currentIncome2 % 1)
                                    .toFixed(2)
                                    .substring(2)}
                                </span>
                              </b>
                            </td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
              </Col>
            </Row>
          )}
          {props.finalDrawdownStrategies?.every(
            (i) =>
              i?.category !== "Self-managed" ||
              Number(i?.strategyPercentage2) === 0,
          ) ? (
            ""
          ) : (
            <>
              <Row className="dd-summary-of-change mb-1 d-none d-xl-block d-lg-block d-md-block">
                <Col>
                  <table>
                    <thead>
                      <tr>
                        <th className="ps-4">
                          Self managed{" "}
                          <OverlayTrigger
                            placement="right"
                            overlay={selfManagedTooltip}
                            flip={true}
                          >
                            <span className="fa-tooltip">
                              <Icons
                                iconname="tool-tip-white"
                                variant="icon-sixteen-px"
                              />
                            </span>
                          </OverlayTrigger>
                        </th>
                        <th className="dd-col-pad-allocation">Allocation</th>
                        <th className="dd-col-pad-total-value">
                          Estimated value
                        </th>
                        <th className="dd-col-pad-total-value">
                          Your drawdown income
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.finalDrawdownStrategies.map((item, index) => {
                        if (
                          item?.category === "Self-managed" &&
                          item.strategyPercentage2 > 0 &&
                          item.strategyName !== "Tax-free cash as income"
                        ) {
                          return (
                            <tr className="mt-3" key={index}>
                              <td className="ps-4">
                                <span>{item.strategyName}</span>
                              </td>
                              <td className="dd-col-pad-allocation">
                                {formatPercent(item.strategyPercentage1)}%{" "}
                                <Icons
                                  iconname="arrow-right-fuchsia"
                                  variant="icon-sixteen-px"
                                />{" "}
                                <b>
                                  {formatPercent(item.strategyPercentage2)}%
                                </b>
                              </td>
                              <td className="dd-col-pad-total-value">
                                £{addCommas(Math.trunc(item.currentValue2))}.
                                <span className="dd-eac-pot-value-small-digit">
                                  {(item.currentValue2 % 1)
                                    .toFixed(2)
                                    .substring(2)}
                                </span>
                              </td>
                              <td className="dd-col-pad-allocation">
                                £{addCommas(Math.trunc(item.currentIncome1))}.
                                <span className="dd-eac-pot-value-small-digit">
                                  {(item.currentIncome1 % 1)
                                    .toFixed(2)
                                    .substring(2)}
                                </span>
                                <Icons
                                  iconname="arrow-right-fuchsia"
                                  variant="icon-sixteen-px"
                                />{" "}
                                <b>
                                  £{addCommas(Math.trunc(item.currentIncome2))}.
                                  <span className="dd-eac-pot-value-small-digit">
                                    {(item.currentIncome2 % 1)
                                      .toFixed(2)
                                      .substring(2)}
                                  </span>{" "}
                                  {item.duration2?.toLowerCase() ===
                                  "Monthly".toLowerCase()
                                    ? "p/m"
                                    : item.duration2?.toLowerCase() ===
                                        "Quarterly".toLowerCase()
                                      ? "p/q"
                                      : item.duration2?.toLowerCase() ===
                                          "Half yearly".toLowerCase()
                                        ? "p/6m"
                                        : item.duration2?.toLowerCase() ===
                                            "Annually".toLowerCase()
                                          ? "p/y"
                                          : ""}
                                </b>
                              </td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </Col>
              </Row>
              <Row
                className={
                  showBreakDown
                    ? "mb-5 d-none d-xl-block d-lg-block d-md-block"
                    : "mb-1 d-none d-xl-block d-lg-block d-md-block"
                }
              >
                <Col>
                  <Buttons
                    className="tertiary-black"
                    name={showBreakDown ? "Show breakdown" : "Hide breakdown"}
                    handleClick={toggleInvestments}
                  />
                  {showBreakDown ? (
                    <span className="icon-margin">
                      <Icons
                        iconname="chevron-down"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : (
                    <span className="icon-margin">
                      <Icons iconname="chevron-up" variant="icon-sixteen-px" />
                    </span>
                  )}
                </Col>
              </Row>
              {!showBreakDown ? (
                <Row className="dd-summary-of-change mb-5 d-none d-xl-block d-lg-block d-md-block">
                  <Col>
                    <table>
                      <thead>
                        <tr>
                          <th className="ps-4">Fund</th>
                          <th className="dd-col-pad-allocation">Allocation</th>
                          <th className="dd-col-pad-total-value">
                            Estimated value
                          </th>
                          <th className="dd-col-pad-total-value"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.finalDrawdownStrategies.map((item) => {
                          if (
                            item?.category === "Self-managed" &&
                            item.strategyName !== "Tax-free cash as income"
                          ) {
                            return item.investments2.map(
                              (investment, index) => {
                                if (investment.fundPercentage > 0) {
                                  return (
                                    <tr className="mt-3" key={index}>
                                      <td className="ps-4">
                                        <span>{investment.fundName}</span>
                                      </td>
                                      <td className="dd-col-pad-allocation">
                                        {formatPercent(
                                          investment.balancePercent,
                                        )}
                                        %{" "}
                                        <Icons
                                          iconname="arrow-right-fuchsia"
                                          variant="icon-sixteen-px"
                                        />{" "}
                                        <b>
                                          {formatPercent(
                                            investment.fundPercentage,
                                          )}
                                          %
                                        </b>
                                      </td>
                                      <td className="dd-col-pad-total-value">
                                        £
                                        {addCommas(
                                          Math.trunc(investment.newBalance),
                                        )}
                                        .
                                        <span className="dd-eac-pot-value-small-digit">
                                          {(investment.newBalance % 1)
                                            .toFixed(2)
                                            .substring(2)}
                                        </span>
                                      </td>
                                      <td></td>
                                    </tr>
                                  );
                                }
                              },
                            );
                          }
                        })}
                      </tbody>
                    </table>
                  </Col>
                </Row>
              ) : (
                ""
              )}
            </>
          )}
          {props.finalDrawdownStrategies?.every(
            (i) =>
              i?.category !== "For Growth" ||
              Number(i?.strategyPercentage2) === 0,
          ) ? (
            ""
          ) : (
            <Row className="dd-summary-of-change mb-5 d-none d-xl-block d-lg-block d-md-block">
              <Col>
                <table>
                  <thead>
                    <tr>
                      <th className="ps-4">
                        For Growth{" "}
                        <OverlayTrigger
                          placement="right"
                          overlay={forGrowthTooltip}
                          flip={true}
                        >
                          <span className="fa-tooltip">
                            <Icons
                              iconname="tool-tip-white"
                              variant="icon-sixteen-px"
                            />
                          </span>
                        </OverlayTrigger>
                      </th>
                      <th className="dd-col-pad-allocation">Allocation</th>
                      <th className="dd-col-pad-total-value">
                        Estimated value
                      </th>
                      <th className="dd-col-pad-total-value"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.finalDrawdownStrategies.map((item, index) => {
                      if (
                        item?.category === "For Growth" &&
                        item.strategyPercentage2 > 0
                      ) {
                        return (
                          <tr className="mt-3" key={index}>
                            <td className="ps-4">
                              <span>{item.strategyName}</span>
                            </td>
                            <td className="dd-col-pad-allocation">
                              {formatPercent(item.strategyPercentage1)}%{" "}
                              <Icons
                                iconname="arrow-right-fuchsia"
                                variant="icon-sixteen-px"
                              />{" "}
                              <b>{formatPercent(item.strategyPercentage2)}%</b>
                            </td>
                            <td className="dd-col-pad-total-value">
                              £{addCommas(Math.trunc(item.currentValue2))}.
                              <span className="dd-eac-pot-value-small-digit">
                                {(item.currentValue2 % 1)
                                  .toFixed(2)
                                  .substring(2)}
                              </span>
                            </td>
                            <td></td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
              </Col>
            </Row>
          )}
          <Row className="dd-summary-of-change mb-5 d-block d-sm-none">
            <Col>
              <table>
                <thead>
                  <tr>
                    <th className="ps-4">Income</th>
                  </tr>
                </thead>
                <tbody>
                  {props.finalDrawdownStrategies.map((item, index) => {
                    if (item?.category === "For Income") {
                      return (
                        <tr className="mt-3" key={index}>
                          <td className="ps-4">
                            <div className="dd-mobile-fund-name">
                              {item.strategyName}
                            </div>

                            <div className="dd-mobile-allocation">
                              <Row className="mb-3">
                                <Col>
                                  <span>Estimated value</span>
                                  <div className="dd-mobile-value">
                                    £{addCommas(Math.trunc(item.currentValue2))}
                                    .
                                    <span className="dd-eac-pot-value-small-digit">
                                      {(item.currentValue2 % 1)
                                        .toFixed(2)
                                        .substring(2)}
                                    </span>
                                  </div>
                                </Col>

                                <Col>
                                  <span>Allocation</span>
                                  <div>
                                    <span className="dd-mobile-value">
                                      {formatPercent(item.strategyPercentage1)}%
                                    </span>{" "}
                                    <Icons
                                      iconname="arrow-right-fuchsia"
                                      variant="icon-sixteen-px"
                                    />{" "}
                                    <span className="dd-mobile-percentage-bold">
                                      {formatPercent(item.strategyPercentage2)}%
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <span>Your drawdown income</span>
                                  <div>
                                    <span className="dd-mobile-value">
                                      {item.currentIncome1}
                                    </span>{" "}
                                    <Icons
                                      iconname="arrow-right-fuchsia"
                                      variant="icon-sixteen-px"
                                    />{" "}
                                    <span className="dd-mobile-percentage-bold">
                                      {item.currentIncome2}
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
            </Col>
          </Row>
          <Row className="dd-summary-of-change mb-5 d-block d-sm-none">
            <Col>
              <table>
                <thead>
                  <tr>
                    <th className="ps-4">Self managed</th>
                  </tr>
                </thead>
                <tbody>
                  {props.finalDrawdownStrategies.map((item, index) => {
                    if (item?.category === "Self-managed") {
                      return (
                        <tr className="mt-3" key={index}>
                          <td className="ps-4">
                            <div className="dd-mobile-fund-name">
                              {item.strategyName}
                            </div>

                            <div className="dd-mobile-allocation">
                              <Row className="mb-3">
                                <Col>
                                  <span>Estimated value</span>
                                  <div className="dd-mobile-value">
                                    £{addCommas(Math.trunc(item.currentValue2))}
                                    .
                                    <span className="dd-eac-pot-value-small-digit">
                                      {(item.currentValue2 % 1)
                                        .toFixed(2)
                                        .substring(2)}
                                    </span>
                                  </div>
                                </Col>

                                <Col>
                                  <span>Allocation</span>
                                  <div>
                                    <span className="dd-mobile-value">
                                      {formatPercent(item.strategyPercentage1)}%
                                    </span>{" "}
                                    <Icons
                                      iconname="arrow-right-fuchsia"
                                      variant="icon-sixteen-px"
                                    />{" "}
                                    <span className="dd-mobile-percentage-bold">
                                      {formatPercent(item.strategyPercentage2)}%
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <span>Your drawdown income</span>
                                  <div>
                                    <span className="dd-mobile-value">
                                      {item.currentIncome1}
                                    </span>{" "}
                                    <Icons
                                      iconname="arrow-right-fuchsia"
                                      variant="icon-sixteen-px"
                                    />{" "}
                                    <span className="dd-mobile-percentage-bold">
                                      {item.currentIncome2}
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
            </Col>
          </Row>
          <Row
            className={
              showBreakDown
                ? "mb-5 d-block d-sm-none"
                : "mb-1 d-block d-sm-none"
            }
          >
            <Col>
              <Buttons
                className="tertiary-black"
                name={showBreakDown ? "Show breakdown" : "Hide breakdown"}
                handleClick={toggleInvestments}
              />
              {showBreakDown ? (
                <span className="icon-margin">
                  <Icons iconname="chevron-down" variant="icon-sixteen-px" />
                </span>
              ) : (
                <span className="icon-margin">
                  <Icons iconname="chevron-up" variant="icon-sixteen-px" />
                </span>
              )}
            </Col>
          </Row>
          {!showBreakDown ? (
            <Row className="dd-summary-of-change mb-5 d-block d-sm-none">
              <Col>
                <table>
                  <thead>
                    <tr>
                      <th className="ps-4">Fund</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.finalDrawdownStrategies.map((item) => {
                      if (
                        item?.category === "Self-managed" &&
                        item.strategyName !== "Tax-free cash as income"
                      ) {
                        return item.investments2.map((investment, index) => {
                          return (
                            <tr className="mt-3" key={index}>
                              <td className="ps-4">
                                <div className="dd-mobile-fund-name">
                                  {investment.fundName}
                                </div>

                                <div className="dd-mobile-allocation">
                                  <Row className="mb-3">
                                    <Col>
                                      <span>Estimated value</span>
                                      <div className="dd-mobile-value">
                                        £
                                        {addCommas(
                                          Math.trunc(investment.newBalance),
                                        )}
                                        .
                                        <span className="dd-eac-pot-value-small-digit">
                                          {(investment.newBalance % 1)
                                            .toFixed(2)
                                            .substring(2)}
                                        </span>
                                      </div>
                                    </Col>

                                    <Col>
                                      <span>Allocation</span>
                                      <div>
                                        <span className="dd-mobile-value">
                                          {formatPercent(
                                            investment.balancePercent,
                                          )}
                                          %
                                        </span>{" "}
                                        <Icons
                                          iconname="arrow-right-fuchsia"
                                          variant="icon-sixteen-px"
                                        />{" "}
                                        <span className="dd-mobile-percentage-bold">
                                          {formatPercent(
                                            investment.fundPercentage,
                                          )}
                                          %
                                        </span>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </td>
                            </tr>
                          );
                        });
                      }
                    })}
                  </tbody>
                </table>
              </Col>
            </Row>
          ) : (
            ""
          )}
          <Row className="dd-summary-of-change mb-5 d-block d-sm-none">
            <Col>
              <table>
                <thead>
                  <tr>
                    <th className="ps-4">For Growth</th>
                  </tr>
                </thead>
                <tbody>
                  {props.finalDrawdownStrategies.map((item, index) => {
                    if (item?.category === "For Growth") {
                      return (
                        <tr className="mt-3" key={index}>
                          <td className="ps-4">
                            <div className="dd-mobile-fund-name">
                              {item.strategyName}
                            </div>

                            <div className="dd-mobile-allocation">
                              <Row className="mb-3">
                                <Col>
                                  <span>Estimated value</span>
                                  <div className="dd-mobile-value">
                                    £{addCommas(Math.trunc(item.currentValue2))}
                                    .
                                    <span className="dd-eac-pot-value-small-digit">
                                      {(item.currentValue2 % 1)
                                        .toFixed(2)
                                        .substring(2)}
                                    </span>
                                  </div>
                                </Col>

                                <Col>
                                  <span>Allocation</span>
                                  <div>
                                    <span className="dd-mobile-value">
                                      {formatPercent(item.strategyPercentage1)}%
                                    </span>{" "}
                                    <Icons
                                      iconname="arrow-right-fuchsia"
                                      variant="icon-sixteen-px"
                                    />{" "}
                                    <span className="dd-mobile-percentage-bold">
                                      {formatPercent(item.strategyPercentage2)}%
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
            </Col>
          </Row>
          {props.fundSwitchError && props.errorShown === true ? (
            <div className="mb-3">
              <NotFound err={props.fundSwitchError} />
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        <div>
          <div className="dd-confirm-desc mb-3">
            Your changes will be made. Changes to drawdown income received on or
            before the 8th of any month will apply to the payment on 5th of the
            following month. Changes received after this date will apply from a
            month later.
          </div>
          <div className="dd-confirm-desc mb-3">
            For example, if a change is received on the 4th of April it would
            apply from your 5th May payment. A change received on 10th April
            would apply from your 5th June payment.
          </div>
        </div>
      )}
      {props?.finalDrawdownStrategies !== undefined ? (
        <>
          <Row className="text-bottom">
            <Col
              className="dd-summary-desc text-bottom mb-3"
              xl={8}
              lg={8}
              md={8}
            >
              <div className="mb-3">
                Changes to drawdown income received on or before the 8th of any
                month will apply to the payment on 5th of the following month.
                Changes received after this date will apply from a month later.
              </div>
              <div className="mb-3">
                For example, if a change is received on the 4th of April it
                would apply from your 5th May payment. A change received on 10th
                April would apply from your 5th June payment.
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={12} lg={12} md={12}>
              <div className="dd-summary-footer-button">
                <div className="dd-summary-cancel-button">
                  <Buttons
                    name="Cancel"
                    className="secondary"
                    variantname="icon-sixteen-px"
                    handleClick={props.handleCloseButton}
                  ></Buttons>
                </div>
                <div>
                  <Buttons
                    name="Continue"
                    className="primary"
                    variantname="icon-sixteen-px"
                    handleClick={handleConfirmClick}
                    fundSwitchFetching={props.fundSwitchFetching}
                    flexiAccessFetching={props.flexiAccessFetching}
                    disabled={
                      confirmLocked ||
                      props.fundSwitchFetching ||
                      props.flexiAccessFetching
                    }
                  ></Buttons>
                </div>
              </div>
            </Col>
          </Row>
        </>
      ) : (
        <div className="dd-confirm-button">
          <Buttons
            name="Continue"
            className="primary"
            variantname="icon-sixteen-px"
            handleClick={props.handleContinue}
          ></Buttons>
        </div>
      )}
    </div>
  );
};

export default DrawSummaryOfChangesModal;
